// React
import React, {useState} from 'react';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {scheduleOrdersAction} from '../orders/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectBundleAssignment,
  makeSelectLoading,
  makeSelectError,
} from '../orders/selectors';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Typography,
  Grid,
  Paper,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
} from '@material-ui/core';

// Components
import List from './list';

// Type
import {Payload, SelectorProps, Props} from './interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      marginTop: theme.spacing(4),
      padding: theme.spacing(4),
      border: '1px solid #ddd',
    },
  })
);

function Assignment(props: Props) {
  const [open, setOpen] = useState(false as boolean);
  const [chance, setChance] = useState('FROM_10_TO_14');

  const handleChangeChance = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChance((event.target as HTMLInputElement).value);
  };

  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography variant="h4" component="h2">
            {`تخصیص بسته‌ها`}
          </Typography>
        </Grid>
        <Grid container item xs={12} sm={6} direction="row-reverse">
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >{`ایجاد و تخصیص اتوماتیک بسته`}</Button>
        </Grid>
      </Grid>
      <Paper elevation={3} square className={classes.paper}>
        {props.bundleAssignment && <List data={props.bundleAssignment} />}
      </Paper>
      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>{'ایجاد و تخصیص اتوماتیک بسته'}</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">{`بازه زمانی`}</FormLabel>
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={chance}
              onChange={handleChangeChance}
            >
              <FormControlLabel
                value="FROM_10_TO_14"
                control={<Radio />}
                label=" 10 صبح تا 14 بعدازظهر"
              />
              <FormControlLabel
                value="FROM_13_TO_17"
                control={<Radio />}
                label=" 13 تا 17 بعدازظهر"
              />
              <FormControlLabel
                value="FROM_16_TO_19"
                control={<Radio />}
                label="16 تا 19 بعدازظهر"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              props.scheduleOrdersDispatch({
                chance,
              });
              handleClose();
            }}
            variant="contained"
            color="primary"
          >
            {`تخصیص`}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  bundleAssignment: makeSelectBundleAssignment(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    scheduleOrdersDispatch: (payload: Payload) =>
      dispatch(scheduleOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Assignment);
